import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import './index.css';
import { METRIC } from '../../lib/types';

class StoneAboveClass extends PureComponent {
  showMc4500 = () => {
    return !this.props.isMc4500Deprecated;
  };

  render() {
    const { lbl, unit, lang, content } = this.props;

    const convertInchesForDisplay = (value) => {
      if (unit === METRIC) return Math.round(Math.round(value * 25.4 * 100) / 100);
      else return value;
    };

    return (
      <table className="main-table" style={{ border: '1px solid' }}>
        <tbody>
          <tr className="gray">
            <td></td>
            <td className="center bold">
              {' '}
              {content[lang].stoneAbove} ({lbl[unit].in[lang]})
            </td>
            <td className="center bold"> {content[lang].notes} </td>
          </tr>
          <tr>
            <td className="bold quarter gray white">Contactor 100HD</td>
            <td
              className="center quarter white weighted-font"
              style={{ borderLeft: '1px solid', borderRight: '1px solid' }}>
              {convertInchesForDisplay(6)}
            </td>
            <td className="half white" rowSpan={3}>
              <strong>a) </strong>
              <span className="weighted-font">{content[lang].notesStoneAbove}</span>
            </td>
          </tr>
          <tr>
            <td className="bold gray white">Recharger 150XLHD</td>
            <td className="center white weighted-font" style={{ borderLeft: '1px solid', borderRight: '1px solid' }}>
              {convertInchesForDisplay(6)}
            </td>
          </tr>
          <tr>
            <td className="bold gray white">Recharger 180HD</td>
            <td className="center white weighted-font" style={{ borderLeft: '1px solid', borderRight: '1px solid' }}>
              {convertInchesForDisplay(6)}
            </td>
          </tr>
          <tr>
            <td className="bold gray white">Recharger 280HD</td>
            <td className="center white weighted-font" style={{ borderLeft: '1px solid', borderRight: '1px solid' }}>
              {convertInchesForDisplay(6)}
            </td>
            <td className="half white" rowSpan={4}></td>
          </tr>
          <tr>
            <td className="bold gray white">Recharger 330XLHD</td>
            <td className="center white weighted-font" style={{ borderLeft: '1px solid', borderRight: '1px solid' }}>
              {convertInchesForDisplay(6)}
            </td>
          </tr>
          <tr>
            <td className="bold gray white">Recharger 300HD</td>
            <td className="center white weighted-font" style={{ borderLeft: '1px solid', borderRight: '1px solid' }}>
              {convertInchesForDisplay(6)}
            </td>
          </tr>
          <tr>
            <td className="bold gray white">Recharger 360HD</td>
            <td className="center white weighted-font" style={{ borderLeft: '1px solid', borderRight: '1px solid' }}>
              {convertInchesForDisplay(6)}
            </td>
          </tr>
          <tr>
            <td className="bold gray white">Recharger 902HD</td>
            <td className="center white weighted-font" style={{ borderLeft: '1px solid', borderRight: '1px solid' }}>
              {convertInchesForDisplay(12)}
            </td>
          </tr>
        </tbody>
      </table>
    );
  }
}

class StoneBelowClass extends PureComponent {
  showMc4500 = () => {
    return !this.props.isMc4500Deprecated;
  };

  showMc7200 = () => {
    return true;
  };

  render() {
    const { lbl, unit, lang, content } = this.props;

    const convertInchesForDisplay = (value) => {
      if (unit === METRIC) return Math.round(Math.round(value * 25.4 * 100) / 100);
      else return value;
    };

    return (
      <table className="main-table" style={{ border: '1px solid' }}>
        <tbody>
          <tr className="gray">
            <td></td>
            <td className="center bold">
              {' '}
              {content[lang].stoneBelow} ({lbl[unit].in[lang]})
            </td>
            <td className="center bold"> {content[lang].notes} </td>
          </tr>
          <tr>
            <td className="bold quarter gray white">Contactor 100HD</td>
            <td
              className="center quarter white weighted-font"
              style={{ borderLeft: '1px solid', borderRight: '1px solid' }}>
              {convertInchesForDisplay(6)}
            </td>
            <td className="half white" rowSpan={3}>
              <strong>a) </strong>
              <span className="weighted-font">{content[lang].notesStoneBelow}</span>
            </td>
          </tr>
          <tr>
            <td className="bold gray white">Recharger 150XLHD</td>
            <td className="center white weighted-font" style={{ borderLeft: '1px solid', borderRight: '1px solid' }}>
              {convertInchesForDisplay(6)}
            </td>
          </tr>
          <tr>
            <td className="bold gray white">Recharger 180HD</td>
            <td className="center white weighted-font" style={{ borderLeft: '1px solid', borderRight: '1px solid' }}>
              {convertInchesForDisplay(6)}
            </td>
          </tr>
          <tr>
            <td className="bold gray white">Recharger 280HD</td>
            <td className="center white weighted-font" style={{ borderLeft: '1px solid', borderRight: '1px solid' }}>
              {convertInchesForDisplay(6)}
            </td>
            <td className="half white" rowSpan={4}></td>
          </tr>
          <tr>
            <td className="bold gray white">Recharger 330XLHD</td>
            <td className="center white weighted-font" style={{ borderLeft: '1px solid', borderRight: '1px solid' }}>
              {convertInchesForDisplay(6)}
            </td>
          </tr>
          <tr>
            <td className="bold gray white">Recharger 360HD</td>
            <td className="center white weighted-font" style={{ borderLeft: '1px solid', borderRight: '1px solid' }}>
              {convertInchesForDisplay(6)}
            </td>
          </tr>
          <tr>
            <td className="bold gray white">Recharger 902HD</td>
            <td className="center white weighted-font" style={{ borderLeft: '1px solid', borderRight: '1px solid' }}>
              {convertInchesForDisplay(9)}
            </td>
          </tr>
        </tbody>
      </table>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    lbl: state.localization.lbl,
    unit: state.localization.unit,
    lang: state.localization.lang,
    content: state.localization.content,
    project: state.project.project,
    projectInfo: state.project.projectInfo,
    isMC4500Deprecated: state.globals.isMC4500Deprecated,
  };
};

const mapDispatchToProps = {};

export const StoneAbove = connect(mapStateToProps, mapDispatchToProps)(StoneAboveClass);

export const StoneBelow = connect(mapStateToProps, mapDispatchToProps)(StoneBelowClass);



// WEBPACK FOOTER //
// ./src/components/Calculations/StoneTables.js